export const sistemachs_pantallas={

}